import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function SuccessComplete(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(
    SvgIcon,
    {
      ...rest,
      "data-tidal": "TidalIllustration",
      "data-tidal-illustration": "SuccessComplete",
      sx,
      viewBox,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M24 42c9.941 0 18-8.059 18-18S33.941 6 24 6 6 14.059 6 24s8.059 18 18 18Z",
            fill: theme.vars.palette.primary.light
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M24 38.625c8.077 0 14.625-6.548 14.625-14.625S32.077 9.375 24 9.375 9.375 15.923 9.375 24 15.923 38.625 24 38.625Z",
            fill: theme.vars.palette.primary.dark
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M21.169 30.75c-.37 0-.741-.135-1.03-.387l-5.847-5.49a1.307 1.307 0 0 1 0-1.915c.556-.522 1.482-.522 2.038 0l4.839 4.544 10.5-9.86c.557-.523 1.483-.523 2.04 0a1.307 1.307 0 0 1 0 1.914L22.177 30.383c-.268.251-.639.367-1.01.367Z",
            fill: theme.vars.palette.secondary.main
          }
        )
      ]
    }
  );
}
SuccessComplete.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "SuccessComplete"
};
validateTidalLicense();
export {
  SuccessComplete
};
//# sourceMappingURL=SuccessComplete.js.map
